import { TimeIntervalEnum } from '../../../shared/enums/time-interval.enum';

/**
 * Interface representing the options for rental agreement reminders.
 */
export class RentalAgreementsReminderOptions {
	/**
	 * Flag indicating if reminders are enabled
	 * @description If false, no reminders will be sent regardless of other settings.
	 */
	enabled!: boolean;

	/**
	 * Time interval before the rental agreement starts to send a reminder
	 * @description If set, a reminder will be sent this long before the start date.
	 */
	beforeStartsAt?: TimeIntervalEnum;

	/**
	 * Time interval after the rental agreement started to send a reminder if the status of the record is still
	 * not in progress.
	 * @description If set, a reminder will be sent this long after the start date if the agreement is overdue.
	 */
	afterStartsAtOverdue?: TimeIntervalEnum;

	/**
	 * Time interval before the rental agreement ends to send a reminder
	 * @description If set, a reminder will be sent this long before the end date.
	 */
	beforeEndsAt?: TimeIntervalEnum;

	/**
	 * Time interval after the rental agreement ended to send a reminder if the status of the record is still
	 * not completed.
	 * @description If set, a reminder will be sent this long after the end date if the record is overdue.
	 */
	afterEndsAtOverdue?: TimeIntervalEnum;
}
